export const BANNER_OFFSET_HIDE = 500;
export const BANNER_HEIGHT = 56;

export type LayoutPrefetchRequest =
  | "staticLayout"
  | "festivalBanner"
  | "footer";

const ALL_LAYOUT_REQUESTS = [
  "staticLayout",
  "festivalBanner",
  "footer",
] as const satisfies readonly LayoutPrefetchRequest[];

export const LAYOUT_PREFETCH_EXCLUSIONS: {
  patterns: readonly string[];
  skip: readonly LayoutPrefetchRequest[];
}[] = [
  {
    patterns: [
      "/login",
      "/register",
      "/my-account/lost-password",
      "/checkout/order-received/application",
    ],
    skip: ALL_LAYOUT_REQUESTS,
  },
  {
    patterns: [
      "/cart",
      "/checkout",
      "/subscription/checkout",
      "/teaching",
      "/jobs",
      "/ev/school",
      "/landing",
      "/direct-payment/contract-result",
    ],
    skip: ["festivalBanner"],
  },
];

export function getSkippedLayoutPrefetchRequests(
  pathname: string
): LayoutPrefetchRequest[] {
  const skipped = new Set<LayoutPrefetchRequest>();

  for (const { patterns, skip } of LAYOUT_PREFETCH_EXCLUSIONS) {
    if (patterns.some((pattern) => pathname.includes(pattern))) {
      for (const request of skip) skipped.add(request);
    }
  }

  return [...skipped];
}
